import { useMemo } from 'react';

import { useAppSelector } from '~/store';

import type { FeatureEntitlement } from './interfaces';
import { makeSelectFeature, selectFlag } from './selectors';

export function useFeature(slug: string) {
  const selectFeature = useMemo(() => makeSelectFeature(slug), [slug]);
  const entitlement: FeatureEntitlement = useAppSelector(selectFeature);

  const isAvailable =
    entitlement.state === 'granted' ||
    entitlement.state === 'trial' ||
    (entitlement.state === 'freemium' && (entitlement.quotaRemaining ?? 0) > 0);

  const isQuotaExhausted =
    entitlement.state === 'freemium' && (entitlement.quotaRemaining ?? 0) <= 0;

  return {
    entitlement,
    state: entitlement.state,
    source: entitlement.source,
    expiresAt: entitlement.expiresAt,
    quotaPerMonth: entitlement.quotaPerMonth,
    quotaUsed: entitlement.quotaUsed,
    quotaRemaining: entitlement.quotaRemaining,
    upgradeRequired: entitlement.upgradeRequired,
    isAvailable,
    isQuotaExhausted,
    isLocked: entitlement.state === 'locked',
    isExpired: entitlement.state === 'expired',
  };
}

export function useFlag(slug: string): boolean {
  const select = useMemo(() => selectFlag(slug), [slug]);
  return useAppSelector(select);
}
